import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconPharmacy$1 = /*@__PURE__*/ proxyCustomElement(class WppIconPharmacy extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-pharmacy", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.41071 3.5C8.27264 3.5 8.16071 3.61193 8.16071 3.75V7.41071C8.16071 7.82493 7.82493 8.16071 7.41071 8.16071H3.75C3.61193 8.16071 3.5 8.27264 3.5 8.41071L3.5 11.5893C3.5 11.7274 3.61193 11.8393 3.75 11.8393H7.41071C7.82493 11.8393 8.16071 12.1751 8.16071 12.5893V16.25C8.16071 16.3881 8.27264 16.5 8.41071 16.5H11.5893C11.7274 16.5 11.8393 16.3881 11.8393 16.25V12.5893C11.8393 12.1751 12.1751 11.8393 12.5893 11.8393H16.25C16.3881 11.8393 16.5 11.7274 16.5 11.5893V8.41071C16.5 8.27264 16.3881 8.16071 16.25 8.16071H12.5893C12.1751 8.16071 11.8393 7.82493 11.8393 7.41071V3.75C11.8393 3.61193 11.7274 3.5 11.5893 3.5H8.41071ZM6.66071 3.75C6.66071 2.7835 7.44422 2 8.41071 2H11.5893C12.5558 2 13.3393 2.7835 13.3393 3.75V6.66071H16.25C17.2165 6.66071 18 7.44422 18 8.41071V11.5893C18 12.5558 17.2165 13.3393 16.25 13.3393H13.3393V16.25C13.3393 17.2165 12.5558 18 11.5893 18H8.41071C7.44422 18 6.66071 17.2165 6.66071 16.25V13.3393H3.75C2.7835 13.3393 2 12.5558 2 11.5893L2 8.41071C2 7.44422 2.7835 6.66071 3.75 6.66071H6.66071V3.75Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-pharmacy-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-pharmacy", "wpp-icon-pharmacy-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-pharmacy-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-pharmacy-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconPharmacy$1);
      }
      break;
  } });
}

const WppIconPharmacy = WppIconPharmacy$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconPharmacy, defineCustomElement };
